import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Popper } from '@mui/material';
import { FindLoad, Images } from 'utils';
import { CloseButton, MinLoader } from 'components';
import { goalActions } from 'store';
import { goalStatusEnums } from './constants';

const ACTION_TYPE = 'EDIT_GOAL_STATUS';

export const GoalStatusBox = ({ info, requestParams, disabled }) => {
    const dispatch = useDispatch();
    const [anchorEl, setAnchorEl] = useState(null);
    const openStatus = Boolean(anchorEl);
    const id = openStatus ? 'goal-status-popper' : undefined;
    const [selected, setSelected] = useState('');
    const loader = FindLoad(ACTION_TYPE);

    const handleClick = (event) => {
        event.preventDefault();
        event.stopPropagation();
        setAnchorEl(anchorEl ? null : event.currentTarget);
    };

    const renderColorAndText = (status) => {
        switch (status) {
            case goalStatusEnums.PENDING:
                return {
                    filter: 'brightness(0) saturate(100%) invert(31%) sepia(98%) saturate(1013%) hue-rotate(17deg) brightness(97%) contrast(96%)',
                    backgroundColor: 'rgb(255, 250, 235)',
                    circleColor: '#B54708',
                    color: '#B54708',
                    text: 'Pending',
                    value: goalStatusEnums.PENDING,
                };
            case goalStatusEnums.ACTIVE:
                return {
                    filter: 'brightness(0) saturate(100%) invert(34%) sepia(82%) saturate(946%) hue-rotate(117deg) brightness(91%) contrast(98%)',
                    backgroundColor: '#E6F9F0',
                    circleColor: '#12B76A',
                    color: '#027A48',
                    text: 'Active',
                    value: goalStatusEnums.ACTIVE,
                };
            case goalStatusEnums.HOLD:
                return {
                    filter: 'brightness(0) saturate(100%) invert(49%) sepia(8%) saturate(444%) hue-rotate(182deg) brightness(92%) contrast(87%)',
                    backgroundColor: '#F2F3F5',
                    circleColor: '#717680',
                    color: '#414651',
                    text: 'Hold',
                    value: goalStatusEnums.HOLD,
                };
            case goalStatusEnums.MASTERED:
                return {
                    filter: 'brightness(0) saturate(100%) invert(33%) sepia(95%) saturate(1584%) hue-rotate(210deg) brightness(97%) contrast(90%)',
                    backgroundColor: '#E6F4FF',
                    circleColor: '#2E90FA',
                    color: '#175CD3',
                    text: 'Mastered',
                    value: goalStatusEnums.MASTERED,
                };
            case goalStatusEnums.DISCONTINUED:
                return {
                    filter: 'brightness(0) saturate(100%) invert(31%) sepia(51%) saturate(3011%) hue-rotate(343deg) brightness(100%) contrast(89%)',
                    backgroundColor: '#FDEDED',
                    circleColor: '#F63D68',
                    color: '#C01048',
                    text: 'Discontinued',
                    value: goalStatusEnums.DISCONTINUED,
                };
            case goalStatusEnums.COMPLETED:
                return {
                    filter: 'brightness(0) saturate(100%) invert(18%) sepia(94%) saturate(1279%) hue-rotate(134deg) brightness(93%) contrast(98%)',
                    backgroundColor: '#e5f3ec',
                    circleColor: '#137045',
                    color: '#046538',
                    text: 'Completed',
                    value: goalStatusEnums.COMPLETED,
                };
            default:
                return { backgroundColor: '', circleColor: '', color: '', text: '' };
        }
    };

    const { filter, backgroundColor, circleColor, color, text } = renderColorAndText(info?.status);

    const statuses = [
        { ...renderColorAndText(goalStatusEnums.PENDING) },
        { ...renderColorAndText(goalStatusEnums.HOLD) },
        { ...renderColorAndText(goalStatusEnums.ACTIVE) },
        { ...renderColorAndText(goalStatusEnums.MASTERED) },
        { ...renderColorAndText(goalStatusEnums.DISCONTINUED) },
        { ...renderColorAndText(goalStatusEnums.COMPLETED) },
    ];

    const handleChangeStatus = (type) => {
        setAnchorEl(null);
        setSelected(info);
        dispatch(goalActions.editGoalStatus(info?.id, { status: type?.value }, requestParams));
    };

    return (
        <div>
            <div className="flex-align-center" style={{ gap: 8 }}>
                <button
                    disabled={disabled}
                    aria-describedby={id}
                    onClick={handleClick}
                    className="status-card-box"
                    style={{ backgroundColor: backgroundColor, border: 'none', height: 28 }}>
                    {text && <div style={{ backgroundColor: circleColor }} />}
                    <p style={{ color: color }}>{text ? text : '--'}</p>
                    {selected?.id === info?.id && loader?.length ? (
                        <MinLoader height={18} width={18} color={circleColor} margin={'0'} position={'relative'} />
                    ) : (
                        !disabled && <img style={{ filter: filter }} src={Images.dropdownArrow} alt="" />
                    )}
                </button>
            </div>

            <Popper
                id={id}
                open={openStatus}
                anchorEl={anchorEl}
                className="status-popper-box"
                placement="bottom-start"
                style={{ position: 'absolute', zIndex: 1500 }}
                onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                }}>
                <div>
                    <div className="status-popper-header">
                        <p>Update Status</p>
                        <CloseButton handleCLic={handleClick} />
                    </div>
                    <div className="status-popper-body">
                        {statuses?.map((i, j) => (
                            <button
                                key={j}
                                onClick={() => handleChangeStatus(i)}
                                className="status-card-box"
                                style={{ backgroundColor: 'transparent', border: 'none' }}>
                                <div style={{ backgroundColor: i?.circleColor }} />
                                <p style={{ color: i?.color }}>{i?.text}</p>
                            </button>
                        ))}
                    </div>
                </div>
            </Popper>
            {openStatus && (
                <div
                    className="beck-drop"
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setAnchorEl(null);
                    }}
                />
            )}
        </div>
    );
};
